// file: frontend/src/components/pages/admin/personas/PersonasTable.jsx
import React from "react";
import { Pencil, Trash2, User } from "lucide-react";

const PersonasTable = ({ personas, onEdit, onDelete, loading }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString();
  };



  return (
    <div className="personas-table-container">
      <div className="bg-bg-60 rounded-lg shadow-sm overflow-x-auto custom-scrollbar">
        <table className="min-w-full divide-y divide-bd-50">
          <thead className="bg-bg-40">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-fg-60 uppercase tracking-wider">
                Persona
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-fg-60 uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-fg-60 uppercase tracking-wider">
                Created
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-fg-60 uppercase tracking-wider">
                Updated
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-fg-60 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-bg-60 divide-y divide-bd-50">
            {loading ? (
              <tr>
                <td colSpan={5} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-3">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ac-02"></div>
                    <p className="text-fg-60 text-sm">Loading personas...</p>
                  </div>
                </td>
              </tr>
            ) : personas.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-6 py-12 text-center">
                    <div className="flex flex-col items-center justify-center space-y-3">
                      <User size={48} className="text-fg-60" />
                      <p className="text-fg-60 text-sm">No personas found.</p>
                    </div>
                  </td>
                </tr>
            ) : (
              personas.map((persona) => (
                <tr key={persona._id} className="hover:bg-bg-50/30">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-10 w-10">
                        <div className="h-10 w-10 rounded-full bg-bg-40 flex items-center justify-center">
                          <User size={20} className="text-fg-60" />
                        </div>
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-fg-100">
                          {persona.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-xs text-fg-80 max-w-xs">
                      <div className="line-clamp-2" title={persona.internal_description}>
                        {persona.internal_description || "-"}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-xs text-fg-60">
                    {formatDate(persona.createdAt)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-xs text-fg-60">
                    {formatDate(persona.updatedAt)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => onEdit(persona)}
                        className="text-fg-60 hover:text-fg-50 p-1 rounded-md hover:bg-bg-50 transition-colors"
                        title="Edit persona"
                      >
                        <Pencil size={16} />
                      </button>
                      <button
                        onClick={() => onDelete(persona)}
                        className="text-fg-60 hover:text-fg-50 p-1 rounded-md hover:bg-bg-50 transition-colors"
                        title="Delete persona"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PersonasTable;